import React from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from 'react-tooltip-lite';

import { IPayment } from '@/modules/payment/types';
import { Typography } from '@/shared/components/atoms';

import ExleminationMark from '~/images/shared/ExleminationMark.svg';

const FieldsInfoCard: React.FC<IPayment.IFieldsSchema> = ({
  activeFields,
  archivedFields,
  paidFields,
}) => {
  const { t } = useTranslation('payment');

  return (
    <div className='flex h-full w-full flex-col gap-24 rounded-xl border-xs border-neutralVariant-90 bg-background-neutral-99 p-24 '>
      <Typography
        variant='body1'
        weight='semiBold'
        className='text-text-default'
      >
        {t('fields')}
      </Typography>
      <div className='flex justify-between '>
        <div className='flex w-full flex-col'>
          <Typography variant='h5' weight='semiBold' className=''>
            {paidFields ?? 0}
          </Typography>
          <Tooltip
            content={
              <div className='relative flex w-fit min-w-[180px] gap-16 rounded-lg bg-background-neutral-99 py-8 px-16 shadow-100'>
                <Typography variant='caption'>
                  {t('paid-fields-description')}
                </Typography>
              </div>
            }
            direction='down'
            arrow={false}
            tipContentHover
          >
            <div className='flex items-center gap-1'>
              <Typography
                weight='medium'
                variant='body1'
                className='text-surface-10'
              >
                {t('paid-fields')}
              </Typography>
              <span className='text-primary-default'>
                <ExleminationMark />
              </span>
            </div>
          </Tooltip>
        </div>
        <div className='flex w-full flex-col border-neutralVariant-90 px-16 ltr:border-l-xs rtl:border-r-xs tablet:px-16 desktop:px-24'>
          <Typography variant='h5' weight='semiBold' className=''>
            {activeFields ?? 0}
          </Typography>
          <Tooltip
            content={
              <div className='relative flex w-fit min-w-[180px] gap-16 rounded-lg bg-background-neutral-99 py-8 px-16 shadow-100'>
                <Typography variant='caption'>
                  {t('active-fields-description')}
                </Typography>
              </div>
            }
            direction='down'
            arrow={false}
            tipContentHover
          >
            <div className='flex items-center gap-1'>
              <Typography
                weight='medium'
                variant='body1'
                className='text-surface-10'
              >
                {t('active-fields')}
              </Typography>
              <span className='text-primary-default'>
                <ExleminationMark />
              </span>
            </div>
          </Tooltip>
        </div>
        <div className='flex w-full flex-col border-neutralVariant-90 px-16 ltr:border-l-xs rtl:border-r-xs tablet:px-16 desktop:px-24'>
          <Typography variant='h5' weight='semiBold' className=''>
            {archivedFields ?? 0}
          </Typography>
          <Tooltip
            content={
              <div className='relative flex w-fit min-w-[180px] gap-16 rounded-lg bg-background-neutral-99 py-8 px-16 shadow-100'>
                <Typography variant='caption'>
                  {t('archived-fields-description')}
                </Typography>
              </div>
            }
            direction='down'
            arrow={false}
            tipContentHover
          >
            <div className='flex items-center gap-1'>
              <Typography
                weight='medium'
                variant='body1'
                className='text-surface-10'
              >
                {t('archived-fields')}
              </Typography>
              <span className='text-primary-default'>
                <ExleminationMark />
              </span>
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export { FieldsInfoCard };
